import { useEffect } from 'react';
import { useSafes, useSafesBalances, useTokenPrices } from 'store';
import { IMultiSignWallet } from 'types';

import { useGetSafeBalance } from './useGetSafeBalance';

export const useLoadSafesBalances = () => {
  const { safes } = useSafes();
  const { safesBalances, setSafesBalances } = useSafesBalances();
  const getSafeBalance = useGetSafeBalance();

  const { tokenPrices: tokenPriceRecord } = useTokenPrices();

  useEffect(() => {
    if (safes?.length && Object.keys(tokenPriceRecord).length) {
      Promise.all(
        (safes.filter((x) => Boolean(x.address)) as unknown as IMultiSignWallet[]).map(
          getSafeBalance
        )
      ).then((balances) => {
        const newSafeBalances: Record<string, number> = { ...safesBalances };
        safes.forEach((s, i) => {
          if (balances[i] !== undefined) {
            newSafeBalances[s.address] = balances[i];
          }
        });
        setSafesBalances(newSafeBalances);
      });
    }
  }, [safes, tokenPriceRecord]);
};
